/**
 * Atlantic Health can only deliver Virtual Care to patients physically located in New Jersey.
 *
 * The geolocation object carries no discrete state field — the state abbreviation is only
 * present as the trailing comma-separated segment of `geo.city` (e.g. "Morristown, NJ"),
 * built by `getCityFromAddressComponents`. Some zip codes geocode without a locality and
 * yield a bare "NJ", so the trailing segment is compared rather than a ", NJ" suffix.
 */
export const isInMarketNJ = (geo) => {
    const city = geo?.city;
    if (!city) return false;
    const parts = city.split(',');
    return parts[parts.length - 1].trim() === 'NJ';
};

/**
 * True when the searched location is in market — either unknown (nothing to gate on) or
 * confirmed New Jersey. Only a confirmed out-of-state location returns false.
 */
export const isInMarketLocation = (geo) => !geo?.city?.trim() || isInMarketNJ(geo);

export default isInMarketLocation;
